"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5631],{

/***/ 85631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PushTraits_PushTraits; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/components/Brandbook/EmailIcon.tsx
var EmailIcon = __webpack_require__(73951);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/components/Brandbook/UserIcon.tsx
var UserIcon = __webpack_require__(75686);
// EXTERNAL MODULE: ../../libs/matcha/recipes/EventItem/index.ts + 2 modules
var EventItem = __webpack_require__(96822);
// EXTERNAL MODULE: ../../libs/matcha/recipes/EventFlow/index.ts + 1 modules
var EventFlow = __webpack_require__(37585);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Marketing/components/PushTraits/PushTraits.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var events = [{
  label: "Emails Today",
  sublabel: "3",
  detail: "24s",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailIcon/* default */.Z, {})
}, {
  label: "Propensity to Buy 14 Days",
  sublabel: "75%",
  detail: "2m",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcon/* default */.Z, {})
}];
var codeEvent = {
  code: "Push traits to build real-time audiences"
};
var PushTraits = function PushTraits() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventFlow/* default */.Z, {
      id: "push-traits",
      gap: "16px",
      gradient: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.48183",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0.5"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        })]
      }),
      gradientDots: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.489183",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        })]
      }),
      children: [events.map(function (event) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventItem/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Icon */.JO, {
            children: event.icon
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventItem/* Body */.uT, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Label */.__, {
              tokens: {
                color: theme.palette.brand.darkAcai[400]
              },
              children: event.label
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Label */.__, {
              children: event.sublabel
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Detail */.F, {
            children: event.detail
          })]
        }, event.label);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* default */.ZP, {
        background: theme.palette.twilio.boysenberry[60],
        size: "small",
        textAlign: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Body */.uT, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Code */.EK, {
            tokens: {
              color: theme.palette.neutrals.white[100]
            },
            children: codeEvent.code
          })
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edzmpi60"
} : 0)( true ? {
  name: "1xtw08w",
  styles: "display:grid;align-items:center;justify-content:center;min-height:430px;padding:0 14px"
} : 0);

/* harmony default export */ var PushTraits_PushTraits = (PushTraits);
;// CONCATENATED MODULE: ./src/views/Marketing/components/PushTraits/index.ts


/***/ })

}]);